
const Footer = () => {


    return (
        <footer className="footer footerdev">
            <nav className="footer-nav">
                <ul>
                    {/*<li><a href="/privacy">Privacy</a></li>*/}
                    {/*<li><a href="/legal">Legal</a></li>*/}
                    {/*<li><a href="/terms">Terms</a></li>*/}
                    {/*<li><a href="/copyright">Copyright</a></li>*/}
                    {/*<li><a href="/site_map">Site Map</a></li>*/}
                    {/*<li><a href="/faq">FAQ</a></li>*/}
                    {/*<li><a href="/contact_us">Contact Us</a></li>*/}
                </ul>
            </nav>
        </footer>

    );
};



export default Footer;
